import TermsAndPoliciesHeader from 'pages/terms-and-policies/header/TermsAndPoliciesHeader'
import TermsAndPoliciesList from 'pages/terms-and-policies/TermsAndPoliciesList'
import React from 'react'

// Why such a simple component? Code as documentation!

const TermsAndPolicies = () => {
  return (
    <>
      <TermsAndPoliciesHeader />
      <TermsAndPoliciesList />
    </>
  )
}

export default TermsAndPolicies
